import { dayKey, formatDayLong, formatWeekday, isToday, sameDay, weekDays } from "../lib/dates";

interface DayStripProps {
  /** Jour sélectionné ; la bande montre sa semaine (lundi → dimanche). */
  selected: Date;
  /** Nombre de rendez-vous actifs par clé de jour. */
  counts: Map<string, number>;
  onSelect: (d: Date) => void;
}

/**
 * Bande des sept jours de la semaine : le jour sélectionné en évidence,
 * aujourd'hui repéré, le nombre de rendez-vous sous chaque date. C'est la
 * navigation de l'agenda sur tablette — un tap par jour, pas de menu.
 */
export function DayStrip({ selected, counts, onSelect }: DayStripProps) {
  return (
    <div className="day-strip" role="group" aria-label="Jours de la semaine">
      {weekDays(selected).map((d) => {
        const key = dayKey(d);
        const n = counts.get(key) ?? 0;
        const classes = [
          "day-strip__day",
          sameDay(d, selected) && "is-selected",
          isToday(d) && "is-today",
          d.getDay() === 0 || d.getDay() === 6 ? "is-weekend" : "",
        ]
          .filter(Boolean)
          .join(" ");
        return (
          <button
            key={key}
            type="button"
            className={classes}
            aria-pressed={sameDay(d, selected)}
            aria-label={`${formatDayLong(d)} : ${n} rendez-vous`}
            onClick={() => onSelect(d)}
          >
            <span className="day-strip__weekday">{formatWeekday(d)}</span>
            <span className="day-strip__date">{d.getDate()}</span>
            <span className={`day-strip__count${n === 0 ? " is-empty" : ""}`}>
              {n > 0 ? n : "·"}
            </span>
          </button>
        );
      })}
    </div>
  );
}
